import qs from 'query-string';

import client from './client';

const PREFIX = '/hospitals';

const HospitalAPI = {
  /* GET */
  getPatientList: ({ page, unassigned, level, doctor, name, checkup }) =>
    client.get(
      `${PREFIX}/patients/?${qs.stringify({
        page,
        unassigned,
        level_types: level,
        checkup_types: checkup,
        doctor,
        name,
      })}`,
    ),

  getPatientDetail: ({ id }) => client.get(`${PREFIX}/patients/${id}/`),

  getMyDoctorData: () => client.get(`${PREFIX}/doctors/me/`),

  getDoctorList: ({ page }) =>
    client.get(`${PREFIX}/doctors/?${qs.stringify({ page })}`),

  getSummarizeDoctorList: () => client.get(`${PREFIX}/doctors/summary/`),

  getFormsetDetail: ({ id }) => client.get(`${PREFIX}/managing/forms/${id}/`),

  getHospitalDetail: ({ id }) => client.get(`${PREFIX}/managing/${id}/`),

  getPaymentList: ({ page, o, doctor, status, name }) =>
    client.get(
      `${PREFIX}/payments/?${qs.stringify({ page, o, doctor, status, name })}`,
    ),

  getReservationList: ({
    page,
    doctor,
    patient,
    month,
    hour,
    weekday,
    weekStart,
    weekEnd,
    notPaid,
    name,
    assigned,
    size,
    isCanceled,
    isDeleted,
    isNoshow,
  }) => {
    return client.get(
      `${PREFIX}/managing/reservations/?${qs.stringify({
        page,
        doctor,
        patient,
        month,
        hour,
        weekday,
        name,
        assigned,
        size,
        not_paid: notPaid,
        weeks_after: weekStart,
        weeks_before: weekEnd,
        is_canceled: isCanceled,
        is_deleted: isDeleted,
        is_noshow: isNoshow,
      })}`,
    );
  },

  checkReservations: ({ date, doctor }) =>
    client.get(
      `${PREFIX}/reservations/check/?${qs.stringify({ date, doctor })}`,
    ),

  getDoctorDetail: ({ id }) => client.get(`${PREFIX}/doctors/${id}/`),

  getSummarizeFormsetList: ({ page, term }) =>
    client.get(
      `${PREFIX}/managing/forms/summary/?${qs.stringify({
        page,
        name: term,
        intro: term,
      })}`,
    ),

  getAssignFormsetList: ({ page, name, doctor, o }) =>
    client.get(
      `${PREFIX}/managing/assigns/?${qs.stringify({ page, name, doctor, o })}`,
    ),

  getAssignFormsetDetail: ({ id }) =>
    client.get(`${PREFIX}/managing/assigns/${id}/`),

  getFormsetCollectionList: ({ page }) =>
    client.get(
      `${PREFIX}/managing/forms/collections/?${qs.stringify({ page })}`,
    ),

  getProtocolList: ({ page }) =>
    client.get(`${PREFIX}/protocols/?${qs.stringify({ page })}`),

  getProtocolDetail: ({ id }) => client.get(`${PREFIX}/protocols/${id}/`),

  /* POST */
  preparePayment: ({ data }) =>
    client.post(`${PREFIX}/payments/prepare/`, data),

  sendRegisterToPatient: ({ data }) =>
    client.post(`${PREFIX}/patients/register-request/`, data),

  createHospital: ({ data }) => client.post(`${PREFIX}/managing/`, data),

  notifyPayment: ({ data }) => client.post(`${PREFIX}/payments/notify/`, data),

  createReservation: ({ data }) => client.post(`${PREFIX}/reservations/`, data),

  createFormset: ({ data }) => client.post(`${PREFIX}/managing/forms/`, data),

  assignFormset: ({ data }) => client.post(`${PREFIX}/managing/assigns/`, data),

  notifyAssign: ({ data }) =>
    client.post(`${PREFIX}/managing/assigns/notify/`, data),

  createFormsetCollection: ({ data }) =>
    client.post(`${PREFIX}/managing/forms/collections/`, data),

  createSubmittedFormset: ({ data }) =>
    client.post(`${PREFIX}/managing/forms/submits/`, data),

  createDoctorProfile: ({ data }) => client.post(`${PREFIX}/doctors/`, data),

  createProtocol: ({ data }) => client.post(`${PREFIX}/protocols/`, data),

  assignProtocol: ({ data }) =>
    client.post(`${PREFIX}/protocols/assigns/`, data),

  downloadFormsetResult: ({ data }) =>
    client.post(`${PREFIX}/managing/forms/exports/`, data, {
      responseType: 'blob',
    }),

  /* PATCH */
  updatePatientProfile: ({ id, data }) =>
    client.patch(`${PREFIX}/patients/${id}/`, data),

  updateHospital: ({ id, data }) =>
    client.patch(`${PREFIX}/managing/${id}/`, data),

  updateDoctorProfile: ({ id, data }) =>
    client.patch(`${PREFIX}/doctors/${id}/`, data),

  updateFormset: ({ id, data }) =>
    client.patch(`${PREFIX}/managing/forms/${id}/`, data),

  updateFormsetCollection: ({ id, data }) =>
    client.patch(`${PREFIX}/managing/forms/collections/${id}/`, data),

  updateReservation: ({ id, data }) =>
    client.patch(`${PREFIX}/managing/reservations/${id}/`, data),

  updateAssignedProtocol: ({ id, data }) =>
    client.patch(`${PREFIX}/protocols/assigns/${id}/`, data),

  updateQuestion: ({ id, data }) =>
    client.patch(`${PREFIX}/managing/questions/${id}/`, data),

  updateStandard: ({ id, data }) =>
    client.patch(`${PREFIX}/managing/standards/${id}/`, data),

  updateSubmittedFormset: ({ id, data }) =>
    client.patch(`${PREFIX}/managing/forms/submits/${id}/`, data),

  /* DELETE */
  deleteHospitalHoliday: ({ id }) =>
    client.delete(`${PREFIX}/managing/holidays/${id}/`),

  deleteHospitalDayHoliday: ({ id }) =>
    client.delete(`${PREFIX}/managing/days/${id}/`),

  deleteDoctorHoliday: ({ id }) =>
    client.delete(`${PREFIX}/doctors/holidays/${id}/`),

  deleteDoctorTime: ({ id }) => client.delete(`${PREFIX}/doctors/times/${id}/`),

  deleteReservation: ({ id, cancel }) =>
    client.delete(
      `${PREFIX}/managing/reservations/${id}/?${qs.stringify({ cancel })}`,
    ),

  deleteFormsetCollection: ({ id }) =>
    client.delete(`${PREFIX}/managing/forms/collections/${id}/`),

  deleteFormset: ({ id }) => client.delete(`${PREFIX}/managing/forms/${id}/`),

  deleteProtocol: ({ id }) => client.delete(`${PREFIX}/protocols/${id}/`),

  deleteAssignedProtocol: ({ id }) =>
    client.delete(`${PREFIX}/protocols/assigns/${id}/`),
};

export default HospitalAPI;
